import type { CollapseProps as MuiCollapseProps } from '@mui/material';
import { Collapse as MuiCollapse } from '@mui/material';

export type CollapseProps = MuiCollapseProps;

/** Collapse component. Based on MUI Collapse: https://mui.com/material-ui/api/collapse/ */
export const Collapse = (props: CollapseProps) => <MuiCollapse {...props} data-testid="collapse" />;
